import React, { useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { validateToken, refreshAccessToken } from '../../ApiLayer/auth';

const ProtectedRoute = ({ children }) => {
  const [isValidating, setIsValidating] = useState(true);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const checkAuth = async () => {
      const accessToken = localStorage.getItem('accessToken');
      const refreshToken = localStorage.getItem('refreshToken');
      
      if (!accessToken || !refreshToken) {
        setIsValidating(false);
        return;
      }

      try {
        const response = await validateToken();
        if (response.error === 'TOKEN_EXPIRED') {
          // Try to refresh the token
          const refreshResponse = await refreshAccessToken(refreshToken);
          if (refreshResponse.success) {
            localStorage.setItem('accessToken', refreshResponse.accessToken);
            setIsAuthenticated(true);
          } else {
            setIsAuthenticated(false);
          }
        } else {
          setIsAuthenticated(response.success);
        }
      } catch (error) {
        setIsAuthenticated(false);
      } finally {
        setIsValidating(false);
      }
    };

    checkAuth();
  }, []);

  if (isValidating) {
    return <div>Loading...</div>; // You might want to replace this with a proper loading component
  }

  if (!isAuthenticated) {
    // Redirect to sign in page but save the attempted location
    return <Navigate to="/admin/signIn" state={{ from: location }} replace />;
  }

  return children;
};

export default ProtectedRoute; 